/**
 * Admin Contexts page component.
 *
 * Route: `/admin/contexts`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminContextsPage
 */

import ContextManager from '@/components/admin/ContextManager';

export default function AdminContextsPage() {
  return <ContextManager />;
}
